function initialState() {
  return {
    audioAdvertisingAvailability: null,
  }
}

let state = initialState()

export { initialState, state }
